<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-btn color="primary" @click="newAnexo" dark>Nuevo Anexo</v-btn>

            <v-dialog
                    v-model="dialog"
                    width="500px" hide-overlay
                    transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Nuevo Anexo</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <div id="app">
                                        <input id="files" type="file" @change="handleFileSelect">
                                        <input id="nameFile"/>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-autocomplete
                                            v-model="anexo.group"
                                            :items="$store.state.procedures"
                                            label="Grupo"
                                            item-text="name"
                                            item-value="name"
                                            required
                                    ></v-autocomplete>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>

                                    <v-select
                                            v-model="anexo.year"
                                            :items="this.years"
                                            label="Año"
                                            @focus="getYears"
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <div class="text-xs-center">
                                <v-btn color="primary" @click="saveFile" dark>Guardar</v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDiagnostic"
                      width="700px" hide-overlay
                      transition="dialog-bottom-transition"
                      scrollable persistent>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialogDiagnostic = false" @click="cleanData">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Diagnóstico</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <template v-slot:header>
                                <div>8. DIAGNOSTICOS</div>
                            </template>
                            <diagnosticos :listaDiagnosticosPadre="this.anexo.diagnostics"
                                          @clicked="onClickChild">
                            </diagnosticos>
                            <v-layout>
                                <v-flex xs12 sm9 offset-sm1>
                                    <v-data-table ref="dtDiagnosticos"
                                                  :headers="[ { text: 'Nombre' }, { text: 'Clase' },{ text: 'Tipo' }]"
                                                  :items="this.anexo.diagnostics"
                                                  class="elevation-1"
                                                  hide-actions
                                    >
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.item.name }}</td>
                                            <td class="text-xs-left" width="120">
                                                <v-select
                                                        :items="clases"
                                                        v-model="props.item.clase"
                                                        label="Clase"
                                                        :rules="[v => !!v || 'Clase es requerida']"
                                                        required
                                                ></v-select>
                                            </td>
                                            <td class="text-xs-left" width="120">
                                                <v-select
                                                        :items="tipos"
                                                        v-model="props.item.tipo"
                                                        label="Tipo"
                                                        :rules="[v => !!v || 'Tipo es requerido']"
                                                        required
                                                ></v-select>
                                            </td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            No se han encontrado resultados para "{{ search }}".
                                        </v-alert>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                            <div class="text-xs-center">
                                <v-btn color="primary" @click="saveFile" dark>Guardar</v-btn>
                            </div>
                            <br>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <textarea id="base64" rows="5" style="display: none"/>
        </v-form>

        <div>
            <v-layout>
                <v-flex xs12 sm6 offset-sm6>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </div>
        <br>
        <br>
        <v-data-table
                :headers="headers"
                :items="this.$store.state.patientFileList"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="search"
                hide-actions
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.fileName }}</td>
                <td class="text-xs-left">{{ props.item.group }}</td>
                <td class="text-xs-left">{{ props.item.year }}</td>
                <td class="text-xs-left"><a @click="download(props.item)">Descargar</a></td>
                <td class="text-xs-left"><a @click="createDiagnostic(props.item)">Agregar diagnóstico</a>
                    <ul id="example-1">
                        <li v-for="item in props.item.diagnostics">
                            {{ item.name }}
                        </li>
                    </ul>
                </td>
                <td>
                    <v-tooltip top>
                        <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                    </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
    </v-container>
</template>
<script>
    import Anexo from "../../../model/Anexo";
    import Diagnosticos from "../diagnosticos/Diagnosticos"

    export default {
        props: ['company'],
        data() {
            return {
                radioGroup: 1,
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                dialogDiagnostic: false,
                diagnostico: {nombre: "", clase: "", tipo: ""},
                groups: ["ACCIDENTE DE TRABAJO",
                    "ALCOHOL EN SANGRE",
                    "ANAMNESIS Y EXAMEN FÍSICO",
                    "ANTÍGENO PROSTÁTICO ESPECÍFICO",
                    "ANTROPOMETRIA",
                    "ANTROPOMETRIA Y SUMA DE PLIEGUES",
                    "AUDIOMETRÍA DE OCTAVAS ",
                    "AUDIOMETRIA DE OCTAVAS Y VALORACIÓN DE ORL ",
                    "AUDIOMETRÍA TONAL E IMPEDANCIOMETRÍA",
                    "BTX",
                    "CA 125",
                    "CERTIFICADO IESS",
                    "CERTIFICADO MÉDICO",
                    "CERTIFICADO MEDICO DE ESPECIALIDAD",
                    "CERTIFICADOS LAB EXTERNOS",
                    "CHEQUEO GINECOLOGICO",
                    "COPRO",
                    "CUESTIONARIO DE FOBIAS",
                    "CUESTIONARIO NORDICO",
                    "DENSITOMETRÍA OSEA",
                    "E DERMATOLOGICO",
                    "ECO ABDOMINAL INFERIOR",
                    "ECO ABDOMEN SUPERIOR",
                    "ECO DE CUELLO",
                    "ECO DE PRÓSTATA",
                    "ECO MAMARIO",
                    "ECO PÉLVICO",
                    "ECO PROSTÁTICO",
                    "ECO TIROIDEO",
                    "ECO-CARDIOGRAMA",
                    "ELECTROCARDIOGRAMA EN REPOSO",
                    "ELECTROENCEFALOGRAMA",
                    "ENDOSCOPIA",
                    "ERGOTEST",
                    "ESPIROMETRÍA",
                    "ESTUDIO ERGONOMICO DE PUESTO DE TRABAJO",
                    "EVALUACIÓN CARDIOLOGICA Y NUTRICIONAL",
                    "EVALUACIÓN FISIOTERAPÉUTICA",
                    "EXAMEN DERMATOLÓGICO",
                    "FROTIS FARÍNGEO",
                    "GHQ12 (ANS/DEP)",
                    "HEMATOZOARIO, DENGUE Y CHAGAS",
                    "HISTORIA CLINICA ESPECIFICA AUDITIVA",
                    "HISTORIA CLINICA ESPECIFICA NUTRICIONAL",
                    "HISTORIA CLINICA ESPECIFICA OFTALMO",
                    "HISTORIA CLINICA ESPECIFICA RESPIRATORIA",
                    "HISTORIA CLINICA ESPECIFICA SALUD MENTAL",
                    "HISTORIA CLINICA ESPECIFICA TME",
                    // "HISTORIA EPIDEMIOLÓGICA ESPECÍFICA DE OTOPATÍA LABORAL",
                    // "HISTORIA EPIDEMIOLÓGICA ESPECÍFICA DERMATOLÓGICA",
                    // "HISTORIA EPIDEMIOLÓGICA ESPECÍFICA MÚSCULO-ESQUÉTICA",
                    // "HISTORIA EPIDEMIOLÓGICA ESPECÍFICA NUTRICIONAL Y METABÓLICA",
                    // "HISTORIA EPIDEMIOLÓGICA ESPECÍFICA RESPIRATORIA",
                    "HOJA DE RETROALIMENTACIÓN",
                    "IMAGEN RXC",
                    "IMAGEN RXT",
                    "IMAGENES",
                    "INFORME",
                    "ISO TR 12295",
                    "ISTAS 21",
                    "KOH de uñas",
                    "LABORATORIO CLÍNICO",
                    "LENTES DE SEGURIDAD",
                    "MAMOGRAFÍA",
                    "MAPA",
                    "MARCADORES BIOLÓGICOS",
                    "MEDICIÓN DE PLIEGUES CUTANEOS",
                    "OTROS",
                    "PAP TEST",
                    "PLAN DE EJERCICIOS",
                    "PLAN DESPARASITACIÓN INFANTIL",
                    "PLOMO EN SANGRE",
                    "PRESIÓN ARTERIAL",
                    "PRUEBA CUANTITATIVA SARS CoV2",
                    "PRUEBA PARCHE",
                    "PRUEBA PSICOLÓGICA PARA CHOFERES",
                    // "PRUEBA TME ISO TR 12295",
                    "PRUEBAS DE EQUILIBRIO",
                    // "PRUEBAS NEUROCONDUCTUALES Q16",
                    "PRUEBAS TIROIDEAS",
                    "PSA",
                    "QUICK DASH",
                    "Q16",
                    "RADIOGRAFÍA DE TÓRAX (CRITERIOS DE LA OIT)",
                    "RAYOS X  COLUMNA DORSAL (AP Y LATERAL)",
                    "RAYOS X COLUMNA LUMBO-SACRA (AP Y LATERAL)",
                    "RAYOS X DE COLUMNA CERVICAL (AP Y LATERAL)",
                    "RAYOS X DE HOMBRO AP",
                    "RAYOS X DE HUESOS PROPIOS DE LA NARIZ",
                    "RAYOS X DE PELVIS",
                    "RAYOS X DE RODILLA",
                    "RAYOS X DE TOBILLO",
                    "RAYOS X DE TORAX",
                    "RAYOS X TORAX Y COLUMNA",
                    "RECETAS MEDICAS",
                    "RECOMENDACIONES EXTERNAS",
                    "REFRIGERIO",
                    "RESULTADOS VARIOS",
                    "RIESGO CARDIOVASCULAR",
                    "ROLAND MORRIS",
                    "RT - PCR",
                    "RX ABDOMINAL 2 POSICIONES",
                    "RX COLUMNA CERVICAL AP Y LATERAL",
                    "RX COLUMNA DORSAL AP Y LATERAL",
                    "RX COLUMNA DORSO LUMBAR APL",
                    "RX COLUMNA LUMBAR AP Y LATERAL",
                    "RX DE PELVIS",
                    "RX DE TORAX",
                    "RX PULGAR IZQUIERDO (AP Y LATERAL)",
                    "RX TORAX AP Y LATERAL",
                    "RX TORAX OIT",
                    "SUMA DE PLIEGUES",
                    "TAC DE NARÍZ Y SPN",
                    "TEST DALTONISMO",
                    "TEST DE DROGAS",
                    "TEST DE DROGAS EN ORINA",
                    "TEST DE ESFUERZO",
                    "TEST DE OSDI",
                    "TEST NÓRDICO",
                    "TEST POSTURAL",
                    "TEST POSTURAL CUESTIONARIO NORDICO ESTANDARIZADO",
                    "TEST PSICOLOGICO",
                    "TEST PSICOLÓGICOS PARA BRIGADISTAS",
                    "TEST WARTEGG",
                    "TIPO DE CONDUCTA",
                    "TSH",
                    "UROLOGIA",
                    "VACUNA DT",
                    "VACUNA HEPATITIS AB",
                    "VACUNA INFLUENZA",
                    "VACUNAS",
                    "VALORACION  PLIBEL",
                    "VALORACIÓN DE CARDIOLOGÍA",
                    "VALORACIÓN FUNCIONAL",
                    "VALORACIÓN FUNCIONAL DE TME",
                    "VALORACION GINECO - OBSTETRICA",
                    "VALORACION NEUROLOGICA",
                    "VALORACIÓN ODONTÓLOGICA MAS PROFILAXIS",
                    "VALORACIÓN OFTALMOLÓGICA",
                    "VALORACIÓN DE ORL",
                    "VALORACIÓN PEDIÁTRICA",
                    "VALORACIÓN PSICOLÓGICA",
                    "VALORACIÓN TRAUMATOLOGICA",
                    "VIH"
                ],
                dialogSuccess: false,
                editedIndex: -1,
                show: false,
                anexo: new Anexo(),
                headers: [
                    {text: 'Nombre', value: 'fileName'},
                    {text: 'Grupo', value: 'group'},
                    {text: 'Año', value: 'year'},
                    {text: 'Descargar', value: 'descargar'},
                    {text: 'Diagnóstico', value: 'diagnostic'},
                    {text: 'Eliminar', value: 'eliminar'}
                ],
                list: [],
                years: [],
                uploadOptions: {
                    headers: {
                        Authorization: 'Client-ID YOURIMGURIDHERE'
                    }
                },
                clases: ["PRE", "DEF"],
                tipos: ["PRI", "SUB", "REF"]
            };
        },
        methods: {
            cleanData() {
                this.anexo = new Anexo()
                this.dialogDiagnostic = false
            },
            newAnexo() {
                this.anexo = new Anexo()
                this.editedIndex = -1
                this.dialog = true
            },
            getDateNow() {
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; //January is 0!

                var yyyy = today.getFullYear()
                today.getHours()
                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                var today = dd + '/' + mm + '/' + yyyy + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                return today
            },
            getYears() {
                let currentYear = new Date().getFullYear()
                for (let i = currentYear; i >= 1945; i--) {
                    this.years.push(i)
                }
            },

            saveFile() {
                if (this.$refs.form.validate()) {
                    // this.anexo.file = document.getElementById('base64').value
                    if (this.editedIndex == -1) {
                        this.anexo.date = new Date()
                        this.anexo.patientRouteSheet = this.$store.state.routeSheet
                        this.anexo.description = this.anexo.group
                        this.anexo.diagnostics = JSON.stringify(this.anexo.diagnostics)
                        this.$store.dispatch('addPatientFile', this.anexo).then(response => {
                            this.dialog = false
                            document.getElementById("files").value = "";
                            this.anexo = new Anexo()
                            this.cleanData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    } else {
                        this.anexo.diagnostics = JSON.stringify(this.anexo.diagnostics)
                        this.$store.dispatch('updatePatientFile', this.anexo).then(response => {
                            this.dialog = false
                            document.getElementById("files").value = "";
                            this.anexo = new Anexo()
                            this.cleanData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },


            deleteItem(item) {
                this.editedIndex = this.$store.state.patientFileList.indexOf(item)
                this.anexo = Object.assign({}, item)
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientFile', this.anexo.id)
            },
            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },
            handleFileSelect(evt) {
                this.$store.state.fileData.push(evt.target.files[0])
                this.anexo.fileName = evt.target.files[0].name
                this.anexo.fileType = evt.target.files[0].type
                this.anexo.file = window.btoa("binaryData");
                let f = evt.target.files[0]; // FileList object
                let reader = new FileReader();
                const self = this;
                // Closure to capture the file information.
                reader.onload = (function (f) {
                    return function (e) {
                        let binaryData = e.target.result;
                        //Converting Binary Data to base 64
                        let base64String = window.btoa(binaryData);
                        self.anexo.file = base64String
                    };
                })(f);
                // Read in the image file as a data URL.
                reader.readAsBinaryString(f);
            },

            download(item) {
                this.editedIndex = this.$store.state.patientFileList.indexOf(item)
                this.$store.dispatch('getPatientFile', this.$store.state.patientFileList[this.editedIndex].id).then(response => {
                    const byteCharacters = atob(response.data.file);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], {type: response.data.fileType});
                    let objectURL = window.URL.createObjectURL(blob);

                    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                        window.navigator.msSaveOrOpenBlob(blob, response.data.fileName);
                    } else {
                        let link = document.createElement('a');
                        link.href = objectURL;
                        link.download = response.data.fileName;
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                }, error => {

                })

            },
            createDiagnostic(item) {
                this.editedIndex = this.$store.state.patientFileList.indexOf(item)
                this.dialogDiagnostic = true
                this.anexo = this.$store.state.patientFileList[this.editedIndex];
            },
            newDiagnostic() {
                this.anexo.diagnostics.push(this.diagnostico)
                this.diagnostico = {nombre: "", clase: "", tipo: ""}
            },
            deleteDiagnostic(item) {
                const index = this.anexo.diagnostics.indexOf(item)
                confirm('Está seguro de que quiere eliminar el registro?') && this.anexo.diagnostics.splice(index, 1)

            },

            reloadData() {
                //this.$store.state.fileData=[]
                this.$store.dispatch('getPatientFileByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },

            onClickChild(value) {
                this.anexo.diagnostics = [];
                this.anexo.diagnostics.push(...value);
                this.$refs.dtDiagnosticos.items = this.anexo.diagnostics;
            }

        },
        computed: {},
        created() {
            this.reloadData()
          this.$store.dispatch('getProcedures').then(
              response => {
                this.cleanData();
              },
              error => {
                this.$store.state.dialogError = true;
              }
          );
        },
        components: {
            Diagnosticos
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/patient/anexos/Anexos.vue